import { ReceiptData } from './service.types';

/**
 * Checks if a fiscal receipt is still valid by comparing the current UTC time
 * against the receipt's fiscal datetime. A receipt is valid when the time elapsed
 * since it was issued is within the `last_receipt` threshold (in seconds).
 */
export const isReceiptValid = (receipt: ReceiptData): boolean => {
    const timeNowUTC = new Date().toISOString().substring(0, 19);
    const timeNowSeconds = Date.parse(timeNowUTC) / 1000;
    const timeReceiptSeconds =
        Date.parse(receipt.current_fiscal_datetime_UTC) / 1000;

    return timeNowSeconds - timeReceiptSeconds <= receipt.last_receipt;
};
